import React from 'react'
import moment from 'moment'
import { Clock9 } from 'lucide-react'
import { REWARDS_COPY } from '@/locales/en'
import { RewardT } from '@/common/types'

type Props = {
    reward: RewardT
}

const RewardItem: React.FC<Props> = ({ reward }) => {
    const expiryEl = reward.expiresAt ? (
        <div className="flex justify-end items-center gap-2">
            <Clock9 size={16} className="text-content-secondary" />
            <div className="justify-center text-content-secondary text-xs font-normal font-['Inter'] leading-5">
                {REWARDS_COPY.expires}
                {(() => {
                    const m = moment(reward.expiresAt)
                    return m.isValid() ? m.format('DD/MM/YYYY') : reward.expiresAt
                })()}
            </div>
        </div>
    ) : null

    return (
        <div className="self-stretch grid gap-2 md:grid-cols-[1fr_auto] md:items-center">
            <div className="flex items-end">
                <div className="justify-start">
                    <span className="text-brand-primary-grass text-xl font-semibold font-['Inter'] leading-6">
                        {reward.quantityRemaining ?? 0}
                    </span>
                    <span className="text-content-secondary text-sm font-medium font-['Inter'] leading-5">
                        /{reward.quantityTotal ?? 0} {REWARDS_COPY.remaining}
                    </span>
                </div>
            </div>

            <div className="self-stretch h-2 relative md:col-span-2 md:row-start-2">
                <div className="w-full h-2 left-0 top-0 absolute bg-brand-dust rounded-[10px]" />
                <div
                    className="h-2 left-0 top-0 absolute bg-brand-primary-grass rounded-[10px]"
                    style={{
                        width: `${Math.round(((reward.quantityRemaining ?? 0) / (reward.quantityTotal ?? 1)) * 100)}%`,
                    }}
                />
            </div>

            <div className="flex justify-start md:justify-end md:row-start-1 md:col-start-2">{expiryEl}</div>
        </div>
    )
}

export default React.memo(RewardItem)
